import { render, staticRenderFns } from "./social.vue?vue&type=template&id=63bbacfc&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"
import style0 from "./social.vue?vue&type=style&index=0&id=63bbacfc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bbacfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bbacfc')) {
      api.createRecord('63bbacfc', component.options)
    } else {
      api.reload('63bbacfc', component.options)
    }
    module.hot.accept("./social.vue?vue&type=template&id=63bbacfc&scoped=true", function () {
      api.rerender('63bbacfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/social.vue"
export default component.exports